import {Component, Output, OnInit, EventEmitter} from '@angular/core';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Observable} from 'rxjs';
import {map, shareReplay} from 'rxjs/operators';
import {AuthService} from '../auth.service';

import { ConfirmDialogComponent } from '../dialog/confirm/confirm-dialog.component';
import { NotificationDialogComponent } from 'src/app/dialog/notification/notification-dialog.component';

import {MatDialog} from '@angular/material/dialog';
import {UserService} from "../me/user.service";

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
    @Output("collapseNavigation") collapseNavigation: EventEmitter<boolean> = new EventEmitter();

    navigationCollapsed = false;
    isAuthenticated: boolean = false;
    user = this.userService.user;

    collapsed = false;
    isPhonePortrait = false;

    isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
        .pipe(
            map(result => result.matches),
            shareReplay()
        );

    constructor(private breakpointObserver: BreakpointObserver,
                private dialog: MatDialog,
                private authService: AuthService,
                protected userService: UserService) {
    }

    ngOnInit() {
        //console.log(`${this} ngOnInit()`);

        this.collapsed = localStorage.getItem("navbar-collapsed") === "f"? false : true;

        // Use breakpoint observer to check the screen size
        this.breakpointObserver.observe(Breakpoints.Handset)
        .subscribe(result => {
            this.isPhonePortrait = false;
            if (result.matches) {

                /*
                * If this is on a small screen / phone, we don't collapse the
                * navigation and use only large icons.
                */

            this.isPhonePortrait = true;
            this.collapsed = false;
            }
        });

        this.authService.isAuthenticated()
            .subscribe(isAuthenticated => this.isAuthenticated = isAuthenticated);
    }

    collapse() {
        this.collapsed = !this.collapsed;
        localStorage.setItem("navbar-collapsed", this.collapsed? "t" : "f");
        this.navigationCollapsed = !this.navigationCollapsed;
        this.collapseNavigation.emit(this.navigationCollapsed);
    }

    login(): void { 
        if(localStorage.getItem("cookieConsent") !== "allow") {
             this.dialog.open(NotificationDialogComponent, {
                 width: '250px',
                 enterAnimationDuration: "200ms",
                 exitAnimationDuration: "200ms",
                 data: {
                     message: "You need to accept the cookie (below) to login. Otherwise, the information about your session can not be stored and you can not use color33. You can delete the cookie afterwards. There are no cookies for advertisement or tracking.",
                     thisPtr: this
                 },
             })
         }
         
          /* If a user is on a smaller devices, we give them a hint that the viewing
             experience may be limited. We let the user confirm to proceed.
          */

        if (this.isPhonePortrait) {
            this.dialog.open(ConfirmDialogComponent, {
                width: '250px',
                enterAnimationDuration: '200ms',
                exitAnimationDuration: '200ms',
                data: {
                    message: "Starting and viewing jobs is not yet optimised for your device. Some parts may not be shown properly. Do you want to continue?",
                    thisPtr: this,
                    confirmAction: () => {
                        this.authService.login();
                    },
                },
            });
        } else {
            this.authService.login();
        }
    }

    logout(): void {
        this.authService.logout();
    }
}
